import { STORAGE_CHECKER_ERROR_MSG } from './constants';
var withStorageChecker = function withStorageChecker(callback) {
  return function () {
    if (typeof Storage !== 'undefined') {
      return callback.apply(void 0, arguments);
    }
    console.error(STORAGE_CHECKER_ERROR_MSG);
  };
};
export default withStorageChecker;